import React from 'react';
import { 
  HardHat, 
  Eye, 
  Smile, 
  Wind, 
  Shirt, 
  Hand, 
  Footprints, 
  Ear, 
  FireExtinguisher, 
  Ruler,
  Anchor,
  AlertTriangle,
  HeartPulse,
  Lock,
  Droplets,
  Wrench,
  Shield
} from 'lucide-react';

// Interface for icon props
interface IconProps {
  className?: string;
}

// Craneana (Casco de seguridad)
export const HelmetIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <HardHat className={className} />
);

// Ocular (Lentes/Gafas de seguridad)
export const EyeProtectionIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Eye className={className} />
);

// Facial (Protector facial)
export const FaceShieldIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Smile className={className} />
);

// Respiratoria (Mascarilla)
export const RespiratoryIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Wind className={className} />
);

// Indumentaria (Chaleco/Protección corporal)
export const ClothingIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Shirt className={className} />
);

// Manos (Guantes)
export const GlovesIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Hand className={className} />
);

// Calzado (Botas de seguridad)
export const FootwearIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Footprints className={className} />
);

// Auditiva (Protección auditiva)
export const HearingProtectionIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Ear className={className} />
);

// Contra Fuego (Protección contra incendios)
export const FireProtectionIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <FireExtinguisher className={className} />
);

// Altura (Protección para trabajos en altura)
export const HeightProtectionIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Ruler className={className} />
);

// Izaje y Sujeción de Cargas
export const RiggingIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Anchor className={className} />
);

// Señalización
export const SignageIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <AlertTriangle className={className} />
);

// Emergencia y Primeros Auxilios
export const EmergencyIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <HeartPulse className={className} />
);

// Bloqueo y Seguridad (LOTO)
export const LockoutIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Lock className={className} />
);

// Derrames y Limpieza
export const SpillCleanIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Droplets className={className} />
);

// Accesorios
export const AccessoriesIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Wrench className={className} />
);

// EPP General
export const EPPIcon: React.FC<IconProps> = ({ className = "w-6 h-6" }) => (
  <Shield className={className} />
);

// Map of category IDs to their respective icons
export const categoryIconMap: Record<string, React.FC<IconProps>> = {
  // Categorías EPP por zona
  'craneana': HelmetIcon,
  'epp-craneana': HelmetIcon,
  'ocular': EyeProtectionIcon,
  'epp-ocular': EyeProtectionIcon,
  'facial': FaceShieldIcon,
  'epp-facial': FaceShieldIcon,
  'respiratoria': RespiratoryIcon,
  'epp-respiratoria': RespiratoryIcon,
  'auditiva': HearingProtectionIcon,
  'epp-auditiva': HearingProtectionIcon,
  'manos': GlovesIcon,
  'epp-manos': GlovesIcon,
  'epp': EPPIcon,
  
  // Categorías principales de catálogo
  'indumentaria': ClothingIcon,
  'calzado': FootwearIcon,
  'altura': HeightProtectionIcon,
  'izaje': RiggingIcon,
  'senalizacion': SignageIcon,
  'emergencia': EmergencyIcon,
  'bloqueo': LockoutIcon,
  'derrames-limpieza': SpillCleanIcon,
  'accesorios': AccessoriesIcon,
  
  // Compatibilidad con identificadores previos
  'contra-fuego': FireProtectionIcon,
  'seguridad-emergencias': EmergencyIcon,
  'limpieza-mantenimiento': SpillCleanIcon
};
